<template>
  <el-button v-if="accountInfoPath" @click="userInfo" size="mini" circle>
    <i class="icon iconfont icon-people"></i>
  </el-button>
</template>

<script>
import { mapGetters } from 'vuex'
import { accountInfoPathOf } from '@/utils/adminRole'

/**
 * 「내 계정 정보」 입구. 갈 곳의 정본은 `utils/adminRole` 한 곳이고, 그 경로가 없을 때만(역할을 모를 때)
 * 버튼을 그리지 않는다. **콜팝 역할 4종도 연다** — 서버 `AccountIssuePolicy.checkRead` 는 자기 계정을
 * 언제나 허용하고, 그 경로가 없으면 새로 발급한 계정이 첫 로그인 비밀번호를 바꿀 방법이 없다.
 */
export default {
  name: 'UserInfoButton',
  computed: {
    ...mapGetters({
      authId: 'auth/authId',
    }),
    accountInfoPath() {
      return accountInfoPathOf(this.authId)
    },
  },
  methods: {
    userInfo() {
      if (!this.accountInfoPath) return

      this.$router.push(this.accountInfoPath).catch(() => {})
    },
  },
}
</script>
